import {
  getMyAuth
} from '@/api/sys.auth'
export default {
  namespaced: true,
  actions: {
    /**
     * @description 查询权限菜单
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     */
    searchMyAuth({
      dispatch
    }, {
      vm,
      data
    }) {
      // var data = [{
      //   authId: '1',
      //   authValue: '/pages/organization',
      //   authName: '机构管理',
      //   children: [{
      //     authId: '2',
      //     authValue: '/pages/organization',
      //     authName: '机构管理2',
      //     children: [{
      //       authId: '3',
      //       authValue: '/pages/organization',
      //       authName: '机构管理3',
      //       children: [],
      //       is_del: '1',
      //       is_add: '1',
      //       is_modify: '1'
      //     }],
      //     is_del: '1',
      //     is_add: '0',
      //     is_modify: '1'
      //   }],
      //   is_del: '1',
      //   is_add: '2',
      //   is_modify: '0'
      // }, {
      //   authId: '4',
      //   authValue: '/pages/organization',
      //   authName: '机构管理',
      //   children: [{
      //     authId: '5',
      //     authValue: '/pages/organization',
      //     authName: '机构管理5',
      //     children: [{
      //       authId: '6',
      //       authValue: '/pages/organization',
      //       authName: '机构管理6',
      //       children: [],
      //       is_del: '1',
      //       is_add: '2',
      //       is_modify: '0'
      //     }],
      //     is_del: '1',
      //     is_add: '2',
      //     is_modify: '0'
      //   }],
      //   is_del: '1',
      //   is_add: '2',
      //   is_modify: '0'
      // }]
      // vm.authList = data
      // var auData = [];
      // for (var i = 0; i < data.length; i++) {
      //   auData.push(data[i])
      //   vm.getChildAuth(data[i], auData)
      // }
      // localStorage.setItem(`authList`, JSON.stringify(auData))
      getMyAuth(data)
        .then(res => {
          vm.authList = res.data.data
          var auData = []
          var data = res.data.data
          for (var i = 0; i < data.length; i++) {
            data[i].can_add = false
            data[i].can_del = false
            data[i].can_modify = false
            auData.push(data[i])
            vm.getChildAuth(data[i], auData)
          }
          localStorage.setItem(`authList`, JSON.stringify(auData))
          localStorage.setItem(`loginAauthList`, JSON.stringify(res.data.data))
        })
        .catch(err => {
          console.log('err: ', err)
        })
    }

  }
}